(ns dre.components.widget.views.content-header
  (:require
   [dre.i18n.views :refer [tr]]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [dre.components.tree :refer [tree]]))

(def component-name :widget-content-header)

(defn view
  [content]
  [:div
   {:class component-name}
   content])